/**
 * Q + A tab — README §1: the host's Party Questions (polls + free text), answers behind a
 * 4px black rule. Reuses PartyQuestionsSection in its `surface` variant; logged-out viewers
 * get the sign-in empty state (the endpoint is authenticated).
 */
import React from 'react';
import { EmptyBox, SurfaceButton } from '../surface';
import PartyQuestionsSection from '../PartyQuestionsSection';

export default function EventQaTab({ eventId, isHost, isAuthenticated, mobile = false, onSignIn }) {
  if (!isAuthenticated) {
    return (
      <EmptyBox title="SIGN IN TO ANSWER." mobile={mobile} testId="qa-signin" action={<SurfaceButton variant="fill" size="sm" onClick={onSignIn}>SIGN IN</SurfaceButton>}>
        The host's questions for the room, and everyone's answers, are for people on Portal.
      </EmptyBox>
    );
  }
  return (
    <div data-testid="qa-tab">
      <PartyQuestionsSection eventId={eventId} isHost={isHost} variant="surface" mobile={mobile} />
    </div>
  );
}
